import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { ReceptionService } from '../services/ReceptionService';

/**
 * Hook para obtener el detalle de una recepción específica
 */
export const useReception = (id: number | null) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  const {
    data: reception,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['reception', id],
    queryFn: () => {
      if (!id) throw new Error('ID de recepción requerido');
      return receptionService.getReception(id);
    },
    enabled: !!id && id > 0,
    staleTime: 30 * 1000, // 30 segundos
    gcTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    reception,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};

